import React, {forwardRef} from 'react';
import { Popover, Button, List, Typography, Divider, Tooltip, Avatar, message } from 'antd';
import useVisibility from './useVisibility';
import * as signalR from '@microsoft/signalr';
import {
  CopyOutlined,
  PushpinOutlined,
  StarOutlined,
  ProfileOutlined,
  InfoCircleOutlined,
  EllipsisOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import './MessageAction.css';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;
interface MessageProps {
groupId: number;
messageDetail: {
  id: number;
  content: string;
  email: string;
  sender: string;
  avatar: string;
  time: string;
  sent: boolean;
  url: string;
  fileName: string;
  status: string;
  groupId?: number;
  isPinned?:boolean;
},
connnection: any
}
const initialMsg = [
    { id: 0, email: '', sender: '', avatar: '', content: '', time: '', sent: false,
      url: '', fileName: '', status:'', groupId:0, isPinned: false
     },
  ];

export const MessageActions =  forwardRef<HTMLDivElement, MessageProps>((props, ref) => {
  const { t } = useTranslation();
const handleVisible = async () => {
    if (props.connnection.state==signalR.HubConnectionState.Connected) {
        try {
            props.connnection.invoke("ChangeSeenStatus", props.messageDetail.id, localStorage.getItem('emailData'), props.groupId);
        } catch (err:any) {
            console.error("Send message failed: ", err.toString());
        }
    }
  };
  const { elementRef } = useVisibility(handleVisible);
  const options = [
    { icon: <CopyOutlined />, label: t('copyMessage') },
    { icon: <PushpinOutlined />, label: t('pinMessage') },
    { icon: <StarOutlined />, label: t('markMessage') },
    { icon: <ProfileOutlined />, label: t('selectMessages') },
    { icon: <InfoCircleOutlined />, label: t('viewDetails') },
    { icon: <EllipsisOutlined />, label: t('moreOptions') }
  ];

  return (
    <div className="message-container"
    ref={(el) => {
        elementRef.current = el; // from useVisibility
        if (typeof ref === 'function') ref(el);
        else if (ref) (ref as React.MutableRefObject<HTMLDivElement | null>).current = el;
      }}
      style={{
        justifyContent: props.messageDetail.sent ? 'flex-start' : 'flex-end',
      }}
    >
      <Avatar
        src={props.messageDetail.avatar}
        size={32}
        className="message-avatar"
      />
      <div className="message-bubble" >
        {props.messageDetail.url==''?
        <Text>{props.messageDetail.content}</Text>:
        ['jpg', 'png', 'bmp', 'jpge'].includes(props.messageDetail.fileName.substring(props.messageDetail.fileName.indexOf('.')+1))?
        <img
  src={props.messageDetail.url} // thay bằng đường dẫn ảnh thật của bạn
  alt="sent-image" 
  className="message-image" />:
          <a onClick={() => {
                const fileName: string = props.messageDetail.id + props.messageDetail.fileName.substring(props.messageDetail.fileName.lastIndexOf('.'));
                fetch(process.env.REACT_APP_API_URL_FOR_CHAT + 'api/Message/' + props.groupId + '/' + fileName, {
                  method: 'GET',
                  headers: {
                    'Authorization':`Bearer ${localStorage.getItem('token')??''}`
                  }
              })
              .then(response => {
                  if (!response.ok) {
                      throw new Error('Failed to fetch file');
                  }
                  return response.blob();
              })
              .then(blob => {
                  if (blob.size === 0) {
                      throw new Error('Downloaded file is empty');
                  }
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = props.messageDetail.fileName;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url); // Cleanup
              })
              .catch(error => {
                  console.error('Error downloading file:', error);
                  alert('Failed to download the file');
              });
              }}>{props.messageDetail.content}</a>
        }
        <div className="message-time">{props.messageDetail.time.toString()}</div>
        <div className="message-time">{props.messageDetail.status}</div>
        <div className="message-actions">
          <Tooltip title={t('more')}>
            <Popover
              content={
                <div className="popover-menu">
                  <List
                    dataSource={options}
                    renderItem={({ icon, label }) => (
                      <List.Item className="popover-item"
                      onClick={()=>{
                          if(label=='pinMessage'){
                              fetch(process.env.REACT_APP_API_URL_FOR_CHAT+'api/Message/messages/pin/' + props.messageDetail.id
                                + '/' + true, {
                                method:'PUT',
                                headers:{
                                  'Authorization': `Bearer ${localStorage.getItem('token')??''}`
                                }
                              })
                              .then(response=>response.json())
                              .then(data=>{
                                  if(data.message == 'Pinned'){
                                      message.info('Bạn đã ghim một tin nhắn');
                                  }
                              })
                              .catch(error=>console.log(error));
                          }
                      }}
                      >
                        {icon}
                        <span>{label}</span>
                      </List.Item>
                    )}
                  />
                  <Divider style={{ margin: '8px 0' }} />
                  <List.Item className="popover-item danger">
                    <DeleteOutlined />
                    <span>{t('deleteForMe')}</span>
                  </List.Item>
                </div>
              }
              trigger="click"
              placement="bottomRight"
            >
              <Button shape="circle" icon={<EllipsisOutlined />} />
            </Popover>
          </Tooltip>
        </div>
      </div>
    </div>
  );
});
